export default "__VITE_ASSET__CRePm16r__"